import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Spline from "cubic-spline";
import * as echarts from "echarts";
import { roRO } from "@mui/material/locale";
import _ from 'lodash';


export const LineGraph = ({ dataProfileTempInfo }) => {
  const { t } = useTranslation();
  const chartRef = useRef(null);
  const myChart = useRef(null);

  useEffect(() => {
    if (!myChart.current && chartRef.current) {
      myChart.current = echarts.init(chartRef.current);
    }
    const data = dataProfileTempInfo;

    // 기본은 10분 로스팅이 10분이 넘으면 최대 MAX + 1분
    const arrLength = data.Time.length < 601 ? 601 : data.Time.length + 60;
    const initTimeArr = Array(arrLength)
      .fill()
      .map((_, index) => index);
    const initArr = Array(arrLength).fill();
    const categories = [...data.Time, ...initTimeArr.slice(data.Time.length)];

    // drum 온도
    const drumTmptValues = [
      ...data.DrumpTmpt,
      ...initArr.slice(data.DrumpTmpt.length),
    ];
    // 터닝 포인트 표시
    // 카라멜 구간 종료 시간
    // 디벨롭 구간 종료 시간
    const dotValues = [...initArr];
    dotValues[data.TurnPntTm] = data.DrumpTmpt[data.TurnPntTm];
    dotValues[data.Caramel[0]] = data.DrumpTmpt[data.Caramel[0]];
    dotValues[data.Develop[0]] = data.DrumpTmpt[data.Develop[0]];

    // 초당 IR 온도 사용 데이터
    const irForSecondsValues = {
      // 0초(시작 시간), 건조 구간 종료 시간, 마이야르 구간 종료 시간, 카라멜 구간 종료 시간, 디벨롭 구간 종료 시간
      x: [
        0,
        data.Drying[0],
        data.Maillard[0],
        data.Caramel[0],
        data.Develop[0],
      ],
      // IR 온도, 건조 구간 종료 시점 IR 온도, 마이야르 구간 종료 시점 IR 온도, 카라멜 구간 종료 시점 IR 온도, 디벨롭 구간 종료 시점 IR 온도
      y: [
        data.IrTmpt,
        data.Drying[1],
        data.Maillard[1],
        data.Caramel[1],
        data.Develop[1],
      ],
    };

    // 보간 작업
    const spline = new Spline(irForSecondsValues.x, irForSecondsValues.y);
    const splineTmptValues = [...initTimeArr].map((value) => {
      // 소수 첫째 자리까지
      const result = Math.round(spline.at(value) * 10) / 10;

      if (result) return result;

      return undefined;
    });
    // 터닝 포인트 표시
    // 카라멜 구간 종료 시간
    // 디벨롭 구간 종료 시간
    const splineDotValues = [...initArr];
    splineDotValues[data.TurnPntTm] = splineTmptValues[data.TurnPntTm];
    splineDotValues[data.Caramel[0]] = splineTmptValues[data.Caramel[0]];
    splineDotValues[data.Develop[0]] = splineTmptValues[data.Develop[0]];

    const option = {
      title: {
        text: '{icon|} ' + t('beens.internaltemptitle'),
        textStyle: {
          color: "#131213",
          rich: {
            icon: {
              height: 24,
              width: 24,
              align: "left",
              backgroundColor: {
                image: 'data:image/png;base64,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',
              }
            },
          },
        },
      },
      legend: {
        left: "left",
        bottom: "5%",
        icon: "rect",
        textStyle: {
          color: "#131213",
        },
        formatter: (name) => {
          switch (name) {
            case "splineTmptValues":
              return t('beens.beansurface');
            case "drumTmptValues":
              return t('beens.internaltemp');
            default:
              return "";
          }
        },
        data: [
          {
            name: "splineTmptValues",
            lineStyle: { color: "#003e8a" },
            itemStyle: { color: "#003e8a" },
          },
          {
            name: "drumTmptValues",
            lineStyle: { color: "#131213" },
            itemStyle: { color: "#131213" },
          },
        ],
      },
      backgroundColor: "transparent",
      tooltip: {
        show: true,
        trigger: "axis",
        backgroundColor: '#eee',
        formatter: (params) => {
          try {
            const x = Number(
              params.find((param) => {
                if (param?.axisValue) {
                  return true;
                }
                return false;
              })?.axisValue
            );
            const time =
              `${Math.floor(x / 60)}`.padStart(2, "0") +
              ":" +
              `${x % 60}`.padStart(2, "0");


            const dumpTmpt = params.find(param => param.seriesName === "drumTmptValues");
            const splineTmpt = params.find(param => param.seriesName === "splineTmptValues");
            const dumpTmptColor = dumpTmpt.color;
            const splineTmptColor = splineTmpt.color;
            const dumpTmptValue = dumpTmpt?.value ?? '';
            const splineTmptValue = splineTmpt?.value ?? '';

            return `<div><span style="display:inline-block;width:100px;">${t('beens.hour')}</span><b>${time}</b></div><div><span style="font-size:20px;color:${splineTmptColor};">● </span><span style="display:inline-block;width:80px;">${t('beens.surface')}</span><b>${splineTmptValue} °C</b></div><div><span style="font-size:20px;color:${dumpTmptColor};">● </span><span style="display:inline-block;width:80px;">${t('beens.internal')}</span><b>${dumpTmptValue} °C</b></div>`;
          } catch (e) {
            console.error(e);
          }
        },
      },
      xAxis: [
        {
          data: categories,
          max: 600,
          axisLabel: {
            interval: 59,
            textStyle: {
              fontSize: 12,
              color: "#131213",
            },
            formatter: (value) => {
              if (value) {
                return `${value / 60}`.padStart(2, "0") + `:00`;
              }

              return "";
            },
            rotate: Math.round(myChart.current._dom.offsetWidth) < 400 ? 45 : 0,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E0E6F1",
              width: 1,
              type: "solid",
            },
          },
        },
        {
          data: categories,
          max: 600,
          axisLabel: {
            interval: 0,
          },
          show: false,
        },
      ],
      grid: {
        left: "4px",
        right: "20px",
        containLabel: true,
        backgroundColor: "#ffffff",
      },
      yAxis: [
        {
          interval: 40,
          max: 260,
          axisLabel: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#131213",
              width: 1,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E0E6F1",
              width: 1,
              type: "solid",
            },
          },
        },
      ],
      series: [
        {
          name: "drumTmptValues",
          data: drumTmptValues.map((value, index) => ({
            value: value,
            itemStyle: {
              color: "#131213",
            },
          })),
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#131213",
          },
          showSymbol: false,
        },
        {
          name: "dotValues",
          data: dotValues.map((value) => ({
            value: value,
            itemStyle: {
              color: "#131213",
            },
          })),
          type: "line",
          label: {
            show: true,
            color: "#131213",
            formatter: ({ name, value }) =>
              `${Math.floor(name / 60)}`.padStart(2, "0") +
              ":" +
              `${name % 60}`.padStart(2, "0") +
              ` ${value} °C`,
          },
          itemStyle: {
            color: "#131213",
          },
          xAxisIndex: 1,
        },
        {
          name: "splineTmptValues",
          data: splineTmptValues.map((value, index) => ({
            value: value,
            itemStyle: {
              color: "#003e8a",
            },
          })),
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#003e8a",
          },
          showSymbol: false,
        },
        {
          name: "splineDotValues",
          data: splineDotValues.map((value) => ({
            value: value,
            itemStyle: {
              color: "#003e8a",
            },
          })),
          type: "line",
          label: {
            show: true,
            color: "#003e8a",
            formatter: ({ name, value }) =>
              `${Math.floor(name / 60)}`.padStart(2, "0") +
              ":" +
              `${name % 60}`.padStart(2, "0") +
              ` ${value} °C`,
          },
          itemStyle: {
            color: "#003e8a",
          },
          xAxisIndex: 1,
        },
      ],
    };
    if (myChart.current) {
      myChart.current.setOption(option);
    }
            
            
    // 창크기 변경할때 카트를 갱신한다.
    const handleResize = _.debounce(() => {
        myChart.current?.resize();
    }, 50); // Debounce for 50ms

    window.addEventListener('resize', handleResize);

    return () => {
        try {
            window.removeEventListener('resize', handleResize);
        
            myChart.current && myChart.current.dispose();
            myChart.current && myChart.current.dispose();
            myChart.current = null;
        }
        catch (err) {
            console.log("Unload", new Date().toISOString(), JSON.stringify(err), err);
        }
    };
  }, [dataProfileTempInfo]);
  return <div ref={chartRef} style={{ width: "100%", height: "800px" }} />;
};
